export default __webpack_public_path__ + "road-map-500-54f378c9027c8ff8a7706f344593d338.png";